import LazyActiveVideo from 'components/ActiveVideo/Lazy'

export default LazyActiveVideo
